import { ANALYSIS_GROUPT_TYPE_MAP, ANALYSIS_GROUP_RATE_LIST } from '@Bill/constants'
import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getPublicScopeTableColumn,
} from '@/utils/common/tableColumn'

export default {
  data () {
    return {
      columns: [],
    }
  },
  computed: {
    groupOpts () {
      const rets = ANALYSIS_GROUP_RATE_LIST.map(item => {
        if (item.t) {
          item.value = this.$t(item.t)
        }
        return item
      })
      return rets
    },
  },
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        formRules: [{
          required: true,
          max: 256,
          message: this.$t('validator.maxLength', ['256']),
        }],
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
      }),
      {
        field: 'group',
        title: this.$t('bill.class_dimension', ['']),
        formatter: ({ row }) => {
          const { group = [], groups = [] } = row.query_attributes?.formData || {}
          const ret = []
          // 旧版本
          if (!groups.length) {
            if (group[0] && group[0] !== 'aggregate_usage_unit') ret.push(this.getLabel(group[0]))
            if (group[1] && group[1] !== 'aggregate_usage_unit') ret.push(this.getLabel(group[1]))
          } else {
            groups.filter(item => item.group !== 'aggregate_usage_unit').forEach(item => {
              ret.push(this.getShowLabel(item))
            })
          }
          return ret.join(',')
        },
        slots: {
          default: ({ row }) => {
            const { group = [], groups = [] } = row.query_attributes?.formData || {}
            const ret = []
            // 旧版本
            if (!groups.length) {
              if (group[0] && group[0] !== 'aggregate_usage_unit') ret.push(this.getLabel(group[0]))
              if (group[1] && group[1] !== 'aggregate_usage_unit') ret.push(this.getLabel(group[1]))
            } else {
              groups.filter(item => item.group !== 'aggregate_usage_unit').forEach(item => {
                ret.push(this.getShowLabel(item))
              })
            }
            return ret.map(text => <a-tag class="mr-2">{text}</a-tag>)
          },
        },
      },
      {
        field: 'date_mode',
        title: this.$t('bill.date_range'),
        formatter: ({ row }) => {
          const { date = {} } = row.query_attributes?.formData || {}
          if (date.date_mode === 'custom') {
            let ret = this.$t('bill.text_45')
            if (date.start_date && date.end_date) {
              ret += ` (${date.start_date.replace('TZ', '')} ~ ${date.end_date.replace('TZ', '')})`
            }
            return ret
          } else {
            return this.$te(`common.date_time.${date.date_mode}`) ? this.$t(`common.date_time.${date.date_mode}`) : date.date_mode || '-'
          }
        },
      },
      {
        field: 'data_type',
        title: this.$t('bill.time_granularity'),
        formatter: ({ row }) => {
          const { date = {} } = row.query_attributes?.formData || {}
          if (date.data_type) {
            return this.$te(`bill.show_group_${date.data_type}`) ? this.$t(`bill.show_group_${date.data_type}`) : date.data_type
          }
          return '-'
        },
      },
      getPublicScopeTableColumn({ vm: this, resource: 'bill_analysis_reports' }),
      getTimeTableColumn(),
    ]
  },
  methods: {
    getTagKey (key) {
      const ret = key.replace('user:', '')
      return ret
    },
    getShowLabel (groupObj) {
      const group = groupObj.group
      const target = this.groupOpts.filter(item => item.key === group)
      if (target.length) {
        if (['tag', 'project_tag', 'instance_tag'].includes(group)) {
          return `${target[0].value} - ${this.$t('bill.key')}${this.getTagKey(groupObj.tag || '-')}`
        }
        return target[0].value
      }
      return ''
    },
    getLabel (key) {
      return ANALYSIS_GROUPT_TYPE_MAP[key]?.value || this.$t(ANALYSIS_GROUPT_TYPE_MAP[key]?.t)
    },
  },
}
